import { combineReducers } from '@reduxjs/toolkit';
import { reducers } from 'features';

const reducer = combineReducers({
  ...reducers,
});

export default reducer;
